import React from 'react';
import { Section } from './ui/Section';
import { Shield, Star } from 'lucide-react';
export function CreatorSection() {
  return <Section className="bg-white" data-id="element-47">
      <div className="max-w-5xl mx-auto" data-id="element-48">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-49">
          {/* Creator Image */}
          <div className="w-full md:w-1/2 relative" data-id="element-50">
            <div className="aspect-square rounded-[3rem] overflow-hidden shadow-xl border-8 border-mint-light relative z-10" data-id="element-51">
              <img src="https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Creadora de Fiesta Creativa" className="w-full h-full object-cover" data-id="element-52" />
              <div className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-black/60 to-transparent p-6" data-id="element-53">
                <p className="text-white font-bold text-xl" data-id="element-54">María Pérez</p>
                <p className="text-white/90 text-sm" data-id="element-55">
                  Fundadora de Fiesta Creativa
                </p>
              </div>
            </div>

            {/* Decorative elements behind image */}
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-yellow-party rounded-full z-0" data-id="element-56"></div>
            <div className="absolute -bottom-6 -right-6 w-40 h-40 bg-partyPink-light rounded-full z-0" data-id="element-57"></div>
          </div>

          {/* Creator Text & Guarantee */}
          <div className="w-full md:w-1/2" data-id="element-58">
            <h2 className="text-3xl md:text-4xl font-black text-gray-800 mb-4" data-id="element-59">
              Creado por mamás,{' '}
              <span className="text-partyPink-hot" data-id="element-60">para mamás</span>
            </h2>
            <p className="text-lg text-gray-600 mb-6 font-medium leading-relaxed" data-id="element-61">
              "Sé lo estresante que puede ser organizar la fiesta perfecta para
              nuestros hijos mientras hacemos malabares con el trabajo y la
              casa. Por eso creé este kit: para devolverte la alegría de planear
              sin el agotamiento de diseñar desde cero."
            </p>

            {/* Guarantee Box */}
            <div className="bg-mint-light rounded-2xl p-6 border-2 border-mint-dark mt-8 relative" data-id="element-62">
              <div className="absolute -top-6 right-6 bg-white rounded-full p-2 shadow-md" data-id="element-63">
                <Shield className="w-8 h-8 text-mint-dark" data-id="element-64" />
              </div>
              <h3 className="font-bold text-xl text-gray-800 mb-2" data-id="element-65">
                Garantía de Satisfacción
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-66">
                Si tienes algún problema técnico con tus archivos o no puedes
                editarlos, nuestro equipo de soporte te ayudará en menos de 24
                horas. ¡Tu tranquilidad es nuestra prioridad!
              </p>
            </div>

            {/* Reviews summary */}
            <div className="mt-8 flex items-center gap-4" data-id="element-67">
              <div className="flex text-yellow-400" data-id="element-68">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" data-id="element-69" />)}
              </div>
              <p className="font-bold text-gray-700" data-id="element-70">
                Más de 5,000 mamás felices
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}